import React from 'react'

const BeAgent = () => {
  return (
    <div style={{marginTop:"80px"}}>BeAgent</div>
  )
}

export default BeAgent